<alaris-card>
	@if (tRows.length > 0 || tRows.length === 0 && state.isFiltersApplied) {
		<div class="table-management">
			<div class="left">
				<span class="total"> {{ totalTitle | translate }}: {{ total }} </span>
				<button (click)="editTableFilter()" alaris-button bType="outline" size="lg">
					<alaris-icon name="icon-filter-vertical"></alaris-icon>
					{{ enableButtons.filters.title | translate }}
					@if (state.isFiltersApplied) {
						<div class="indicator"></div>
					}
				</button>
			</div>
			<div class="right">
				<button (click)="refresh()" alaris-button bType="outline" size="lg">
					<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
					{{ 'actions.refresh_page' | translate }}
				</button>
				<button (click)="export()" [disabled]="!!(exporting$ | async)" alaris-button bType="outline" size="lg"
					[disabled]="!this.user.allowed(['rules.edit'])">
					@if (exporting$ | async) {
						<alaris-spinner></alaris-spinner>
					} @else {
						<alaris-icon name="icon-export"></alaris-icon>
					}
					{{ 'gl.export' | translate }}
				</button>
				<button (click)="edit()" alaris-button bType="primary" size="lg" [disabled]="!this.user.allowed(['rules.edit'])">
					<alaris-icon class="in-primary" name="icon-plus"></alaris-icon>
					{{ 'rules.add' | translate }}
				</button>
			</div>
		</div>
	}
	<div [alarisLoading]="loading$" alarisHorizontalOverflow class="content">
		@if (tRows.length === 0 && !state.isFiltersApplied) {
			<app-empty-table type="rules" [disabled]="!this.user.allowed(['rules.edit'])" (newRule)="edit()"></app-empty-table>
		} @else {
			<alaris-table (filterChange)="_applyFilter($event)"
						  (sortingChange)="_applySorting($event)"
						  [filters]="state.filters"
						  [dblClickRowAction]="dblClickRowAction.bind(this)"
						  [dropDownRowActions]="dropDownRowActions"
						  [rowActions]="rowActions"
						  [tHeaders]="tHeaders"
						  [tRows]="tRows"
						  [templates]="{productList, productsNames, productsType, prefixList, choiceListName, senderList}"
						  [resizable]="resizable"
						  alarisOverflowFader>
			</alaris-table>
		}
	</div>
	<div class="footer">
		<alaris-pagination (page)="_pageChange($event)"
						   [activePage]="activePage"
						   [class.without-table-bar]="selection !== null && selection.length === 0"
						   [hidden]="total === 0"
						   [pageSizeOptions]="pageSizeOptions"
						   [pageSize]="pageSize"
						   [total]="total"
						   class="pagination">
		</alaris-pagination>
	</div>
</alaris-card>

<ng-template #productList [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="tagFilter">
		@if (productsService.loading$ | async) {
			<alaris-spinner size="xs" style="transform: scale(0.5,0.5)"></alaris-spinner>
		} @else {
			@for (prod of data.productList; track prod) {
				@if (prod) {
					@if (!eapiEnable) {
						<div class="text-ellipsis">{{ prod }}</div>
					} @else {
						<div class="text-ellipsis">{{ transform(prod)?.product_caption }}</div>
					}
				} @else {}
			}
		}
	</div>
</ng-template>

<ng-template #productsNames [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="tagFilter">
		@if (productsService.loading$ | async) {
			<alaris-spinner size="xs" style="transform: scale(0.5,0.5)"></alaris-spinner>
		} @else {
			@for (e of data.productsNames; track e) {
				<alaris-tag>{{ e }}</alaris-tag>
			}
		}
	</div>
</ng-template>

<ng-template #productsType [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="tagFilter">
		@if (productsService.loading$ | async) {
			<alaris-spinner size="xs" style="transform: scale(0.5,0.5)"></alaris-spinner>
		} @else {
			<alaris-tag>{{ data.productsType }}</alaris-tag>
		}
	</div>
</ng-template>

<ng-template #prefixList [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="tagFilter">
		@for (e of data.prefixList; track e) {
			<alaris-tag>{{ e }}</alaris-tag>
		}
	</div>
</ng-template>

<ng-template #choiceListName [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="tagFilter">
		@for (e of data.choiceListName; track e) {
			<alaris-tag>{{ e }}</alaris-tag>
		}
	</div>
</ng-template>

<ng-template #senderList [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="tagFilter">
		@for (e of data.senderList; track e) {
			<alaris-tag>{{ e }}</alaris-tag>
		}
	</div>
</ng-template>
